import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { CpModule } from './cp/cp.module';
import { CdcLojaModule } from './cdc-loja/cdc-loja.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    CdcLojaModule,
    CpModule
  ]
})
export class ProdutosModule {}
